import commApi from "@/api/apis/common.js";
// 生成32位字符串
export function getRandomStr32() {
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  var str_nums = "";
  for (var i = 0; i < 32; i++) {
    var id = parseInt(Math.random() * (arr.length - 1));
    str_nums += arr[id];
  }
  return str_nums;
}

// 微信授权登录
export function wxUserInfoAuthorize(callbackURL, wxAppId, state) {
  var redirect = encodeURIComponent(callbackURL || window.location.href);
  var state = state || 1;
  window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + wxAppId + "&redirect_uri=" + redirect + "&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect");
}

// 深度复制
export function deepClone(obj) {
  let result = Array.isArray(obj) ? [] : {}
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = obj[key] !== null ? deepClone(obj[key]) : obj[key]
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

// 验证是否是手机号
export function testMobilePhone(phoneNum) {
  // var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return reg.test(phoneNum);
}

/* 获取URL中的某个参数 */
export function getUrlParamByKey(key) {
  var str = window.location.href;
  if (str.indexOf('?') > -1) {
    str = str.split('?')[1];
    var list = str.split("&");
    for (var i = 0; i < list.length; i++) {
      var k = list[i].split("=")[0];
      var v = list[i].split("=")[1];
      if (k == key) return v;
    }
  }
  return null;
}

// 获取URL中的全部参数
export function getUrlParamObj(url) {
  var arr = [];
  var query = {};
  if (url.indexOf('?') > -1) {
    arr = url.split('?')[1];
    if (arr.length > 0) {
      var list = arr.split("&");
      list.length > 0 && list.forEach(item => {
        let mm = item.split('='),
          key = mm[0],
          value = mm[1];
        query[key] = value
      });
    }
  }
  return query;
}

/* 获取选项标签 */
export function getSelectLabel(index) {
  var list = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  return list[index];
}

// 点击量
export function clickPlayCount(params) {
  var p = {
    categoryType: 0, // 栏目类型:0、普通栏目；1、首页栏目；2、精品栏目 3、推广栏目
    channelId: '', // 栏目id
    channelName: '', // 栏目名称
    contentCreationTime: '', // 创建时间
    contentId: '', // 稿件Id
    contentTitle: '', // 稿件title
    contentType: '', // 内容类型: 1、活动；2、抽奖；3、投票调查；4、直播间；5、图文资讯；6、图集;7、专题；8、占位广告；9、视频 ；10、问卷调查；11、音频； 12、外链；13、自媒体；16、报料 ,17弹窗广告,18:启动页广告
    deviceId: '', // 设备id
    deviceType: 4, // 设备标识1:华为2:小米3:苹果4：未知
    memberId: null, // 会员id
    nickName: '', // 用户名称
    sourceType: 4, // 1:苹果;2:安卓;3web;4:H5
  }

  params = Object.assign(p, params);
  params.deviceId = getRandomStr32();

  commApi
    .clickPlayCount(params)
    .then((res) => {
      console.log("统计成功，访问量+1！");
    })
    .catch((err) => {
      console.log("统计成功，访问量+1！");
    });
}

// 增加积分
export function addScore(params) {
  var p = {
    code: "", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、zbj、dy、dz、sc)
    description: "", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、直播间、订阅、点赞、收藏)
    contentType: "", // 非必传，稿件的type
    contentId: "", // 非必传，稿件的id
    contentName: "", // 非必传，稿件的标题
    // deviceId:, // 设备id，客户端则传设备id，静态页不传
    memberId: null, // 必传，会员id
  };
  params = Object.assign(p, params);

  commApi
    .addScore(params)
    .then((res) => {
      if (res.suc == 1) {
        console.log("积分添加成功！");
      } else {
        console.log("积分添加失败！");
      }
    })
    .catch((err) => {
      console.log("积分添加失败！");
    });
}